module.exports = "/fonts/hashed/NotoSansSC-Bold.9f39792a.ttf.gz.bin";